import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-action-thank-you',
  templateUrl: './action-thank-you.component.html',
  styleUrls: ['./action-thank-you.component.scss']
})
export class ActionThankYouComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  thankYouMessage: string;
  identifier: string;
  isInternal: boolean;
  jobBoardIdentifier: string;

  constructor(private readonly route: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.subscription.add(
      this.route.paramMap.subscribe(params => {
        this.identifier = params.get('identifier');
        this.jobBoardIdentifier = params.get('jobBoardIdentifier');
      })
    );
    this.subscription.add(
      this.route.data.subscribe(
        data => {
          this.thankYouMessage = data.thankYouMessage;
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  goToJobsPage() {
    if (this.jobBoardIdentifier !== null) {
      this.router.navigate([this.identifier, 'internal', this.jobBoardIdentifier]);
    } else {
      this.router.navigate([this.identifier]);
    }
  }
}
